import heroImage from "@/assets/pardue-center-enhanced.jpg";

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Elegant wedding reception at The Pardue Center"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-sky-900/70 via-sky-800/50 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-5xl mx-auto animate-fade-in-up pt-20">
        {/* Brand Name - Text Only */}
        <h2 className="font-serif text-3xl md:text-4xl text-primary-foreground mb-4 tracking-wide">
          Gracious Gatherings
        </h2>
        <p className="text-primary-foreground/80 text-lg tracking-widest uppercase mb-2">
          Catering
        </p>
        
        {/* Divider */}
        <div className="flex justify-center mb-4">
          <span className="text-primary-foreground/60 text-2xl">⚜</span>
        </div>

        {/* Location Tagline */}
        <p className="text-primary-foreground/80 text-sm md:text-base font-light tracking-wider uppercase mb-8">
          At The <span className="font-bold">Pardue</span> Family Foundation Event Center
        </p>

        {/* Main Headline - reformatted for visual appeal */}
        <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl text-primary-foreground mb-4 leading-relaxed max-w-3xl mx-auto">
          Where Every Gathering Is Gracious
        </h1>
        <p className="font-serif text-2xl md:text-3xl lg:text-4xl text-primary-foreground/90 italic mb-10 max-w-2xl mx-auto">
          Chef-Crafted, Heartfelt & Unforgettable
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#booking"
            className="btn-gold px-8 py-4 rounded-full text-lg font-semibold hover:scale-105 transition-transform duration-300"
          >
            Plan Your Event
          </a>
          <a
            href="#menus"
            className="px-8 py-4 rounded-full text-lg font-medium text-primary-foreground border-2 border-primary-foreground/40 hover:bg-primary-foreground/10 transition-all duration-300"
          >
            Explore Our Menus
          </a>
        </div>

        {/* Location */}
        <p className="mt-12 text-primary-foreground/70 text-sm tracking-wide">
          📍 205 Cox Road, Milton, GA 30075
        </p>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-primary-foreground/40 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-primary-foreground/60 rounded-full mt-2" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
